import { Controller } from 'stimulus';

// Submits the controller's form when an input fires the `submit` action.
// Used by direct toggle/switch settings (e.g. Communication Preferences) so a
// change persists immediately without an explicit save button.
export default class extends Controller {
  submit() {
    if (this.element.requestSubmit) {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
}
